import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";

import { TinyIcon } from "core/styles";

import {
  CheckboxGrid,
  CheckboxGroupContainer,
  CheckboxGroupItem,
  CheckboxGroupLabel as Label,
  CheckboxSkeletonContainer,
  LabelTextWithIcon,
} from "./styles";
import { Tooltip } from "react-tooltip";
import { splitFormProps, useField } from "react-form";

export const CheckboxLabelWithIcon = ({ info, icon, children }) => {
  return (
    <LabelTextWithIcon>
      {children}
      <TinyIcon icon={icon} id={children} />
      <Tooltip anchorId={children} html={info} positionStrategy="fixed" />
    </LabelTextWithIcon>
  );
};

CheckboxLabelWithIcon.propTypes = {
  children: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  info: PropTypes.string,
};

const CheckboxField = React.forwardRef((props, ref) => {
  const [field, fieldOptions, rest] = splitFormProps(props);
  const { value, setValue, getInputProps } = useField(field, {
    ...fieldOptions,
  });

  const onChange = (event) => {
    setValue(event.target.checked);
  };

  return (
    <input
      type="checkbox"
      {...getInputProps({ ref, ...rest })}
      onChange={onChange}
      checked={value}
    />
  );
});

const CheckboxGroup = React.forwardRef(
  ({ label, options = [], isLoading = false, children }, ref) => {
    if (isLoading) {
      return (
        <CheckboxGroupContainer ref={ref}>
          <Label>{label}</Label>
          <CheckboxSkeletonContainer>
            <Skeleton />
          </CheckboxSkeletonContainer>
        </CheckboxGroupContainer>
      );
    }

    return (
      <CheckboxGroupContainer ref={ref}>
        <Label>{label}</Label>
        <CheckboxGroupContainer>
          <CheckboxGrid>
            {options.map(({ field, label: optionLabel }) => (
              <CheckboxGroupItem key={field}>
                <CheckboxField field={field} />
                <Label>{optionLabel}</Label>
              </CheckboxGroupItem>
            ))}
          </CheckboxGrid>
        </CheckboxGroupContainer>
        {children}
      </CheckboxGroupContainer>
    );
  }
);

CheckboxGroup.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  label: PropTypes.node,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string.isRequired,
      label: PropTypes.node,
    })
  ),
};

export default CheckboxGroup;
